import {
    ModerationVerdict,
    PaymentStatus,
    SurveyAudience,
    SurveyPrice,
    SurveyScope,
    SurveyType
} from 'client/common/types';

import {Survey} from 'client/common/store/reducers/survey/types';

export interface SurveyItem extends Omit<Survey, 'context' | 'boxName'> {
    audience: SurveyAudience;
    clientId?: string;
    clientName?: string;
    cost: SurveyPrice;
    isLoading: boolean;
    surveyType: SurveyType;
    surveyScope: SurveyScope;
    paymentStatus: PaymentStatus;
    moderationVerdict?: ModerationVerdict['state'];
}

export function isSurveyItem(survey: ListItem): survey is SurveyItem {
    return (survey as SurveyItem).slug !== undefined;
}

export interface DummyItem {
    isLoading: boolean;
}

export type ListItem = SurveyItem | DummyItem;

export enum StateFilterValue {
    All = 'ALL',
    Draft = 'DRAFT',
    Moderation = 'MODERATION',
    Active = 'ACTIVE',
    Paused = 'PAUSED',
    Completed = 'COMPLETED',
    Closed = 'CLOSED'
}

export interface ListFilter {
    clientId?: string;
    name?: string;
    state: StateFilterValue;
    surveyType?: SurveyType[];
    orgIds?: number;
}

export enum ListMode {
    Agency = 'agency',
    AgencyClient = 'agency-client',
    User = 'user'
}

export interface SurveysStore {
    paginationKey?: string;
    filter: ListFilter;
    list: ListItem[];
    isEntirelyLoaded: boolean;
    IsLoadingSurveysList: boolean;
}

export interface FetchSurveyListPayload {
    isCreativeAssessor: boolean;
}

export interface SavePaginationKeyPayload {
    paginationKey: string;
}

export interface ChangeClientIdFilterPayload {
    clientId?: string;
}

export interface ChangeNameFilterPayload {
    name?: string;
}

export interface ChangeOrgIdFilterPayload {
    orgIds?: number;
}

export interface ChangeStateFilterPayload {
    state: StateFilterValue;
}

export interface PushToSurveyListPayload {
    position?: number;
    items: ListItem[];
}

export interface ReplaceSurveyListItemPayload {
    position: number;
    item: SurveyItem;
}

export interface UpdateSurveyListItemPayload {
    slug: string;
    fields: Partial<SurveyItem>;
}

export interface RemoveSurveyListItemPayload {
    slug: string;
}
